import { useSelector } from "react-redux";
import { useState } from "react";
import { toast } from "react-toastify";
import { useTranslate } from "../context/TranslationContext";
import { useGenerateUploadUrlMutation } from "../redux/Apis/General";

const usePresignedUpload = () => {
  const lang = useSelector((state) => state.language.lang);
  const { t } = useTranslate("courseDatailController");
  const [generateUploadUrl] = useGenerateUploadUrlMutation();
  const [isUploadingPresigned, setIsUploadingPresigned] = useState(false);

  const uploadFileWithPresignedUrl = async (file, options = {}) => {
    if (!(file instanceof File)) {
      toast.error(t("errors.invalidFileSelected"));
      return null;
    }

    try {
      setIsUploadingPresigned(true);
      const { name, type } = file;
      const { onProgress } = options;

      // const { uploadURL, key } = await generateUploadUrl({
      //   filename: name,
      //   filetype: type,
      //   lang: lang,
      // }).unwrap();

      const presignRes = await generateUploadUrl({
        filename: name,
        filetype: type,
        lang,
      }).unwrap();
      const uploadURL = presignRes?.data?.uploadURL;
      const key = presignRes?.data?.key;

      if (!uploadURL || !key) {
        throw new Error(t("errors.uploadUrlMissing"));
      }

      await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("PUT", uploadURL, true);
        xhr.setRequestHeader("Content-Type", type);

        xhr.upload.onprogress = (event) => {
          if (typeof onProgress === "function" && event.lengthComputable) {
            const percent = Math.round((event.loaded * 100) / event.total);
            onProgress(percent);
          }
        };

        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            resolve();
          } else {
            reject(new Error(`Upload failed: ${xhr.status}`));
          }
        };

        xhr.onerror = () => reject(new Error(t("errors.networkUploadError")));
        xhr.onabort = () => reject(new Error(t("errors.uploadAborted")));
        xhr.send(file);
      });

      return key;
    } catch (err) {
      console.error("Presigned upload failed:", err);
      toast.error(err?.data?.message || err?.message || t("errors.fileUploadFailed"));
      return null;
    } finally {
      setIsUploadingPresigned(false);
    }
  };

  return { uploadFileWithPresignedUrl, isUploadingPresigned };
};

export default usePresignedUpload;
